module.exports = __webpack_public_path__ + "static/media/referral.941be95b.svg";